import type { LicenseDurationOption } from './types';

/** null = indefinida (válida). undefined/''/fuera de 1–99 = sin vigencia usable. */
export function isDurationMapValid(durationMap: string | null | undefined): boolean {
  if (durationMap === null) return true;
  const mapYears = Number(durationMap || 0);
  return Number.isInteger(mapYears) && mapYears >= 1 && mapYears <= 99;
}

/** Mensaje de error al guardar si la vigencia falta o no es válida. */
export function durationMissingValidityError(
  duration: Pick<LicenseDurationOption, 'code' | 'label' | 'durationMap'>
): string | null {
  if (isDurationMapValid(duration.durationMap)) return null;
  const label = (duration.label || '').trim() || duration.code;
  return `"${label}" (${duration.code}): falta la vigencia en años (1–99, o indefinida)`;
}

export function recipeHasDurationWithoutValidity(recipe: {
  durationOptions: Array<Pick<LicenseDurationOption, 'durationMap'>>;
}): boolean {
  return recipe.durationOptions.some((duration) => !isDurationMapValid(duration.durationMap));
}
